module.exports = __webpack_public_path__ + "img/how_it_works_icon_1.ead0b84c.png";